import { Workflow } from "lucide-react"

import { numeralDeProceso } from "@/lib/numeral"

import type { Proceso } from "./tipos"

/** La columna izquierda de «Procesos»: todos, con su numeral y cuántos pasos tienen. */
export function ListaProcesos({
  procesos,
  todos = procesos,
  elegidoId,
  onElegir,
}: {
  procesos: Proceso[]
  /**
   * La lista ENTERA, de la que sale el numeral. ⚠ Con un filtro puesto, numerar sobre
   * lo filtrado haría que el III pasara a llamarse I: el numeral es del manual, no de
   * la vista.
   */
  todos?: Proceso[]
  elegidoId: number | undefined
  onElegir: (id: number) => void
}) {
  if (procesos.length === 0) {
    return (
      <div
        className="flex flex-col items-center gap-3 superficie py-12"
        style={{ color: "var(--fg-muted)" }}
      >
        <Workflow size={24} aria-hidden={true} />
        <p className="px-4 text-center text-sm">
          {todos.length === 0 ? "Todavía no hay procesos." : "Ningún proceso de esa área."}
        </p>
      </div>
    )
  }

  return (
    <ul className="superficie overflow-hidden">
      {procesos.map((p, i) => (
        <li key={p.id} style={i === 0 ? undefined : { borderTop: "1px solid var(--cristal-filo)" }}>
          <button
            type="button"
            onClick={() => onElegir(p.id)}
            data-testid={`proceso-${p.id}`}
            aria-current={p.id === elegidoId}
            className="block w-full px-3 py-2 text-left text-sm toque-cristal"
            style={
              p.id === elegidoId
                ? { backgroundColor: "var(--primary-suave)", color: "var(--primary-texto)" }
                : undefined
            }
          >
            <span className="block font-medium" style={{ opacity: p.activo ? 1 : 0.55 }}>
              {/* El numeral sale del orden, no de una columna: reordenar lo
                  recalcula solo. Ver `lib/numeral.ts`. */}
              <span className="tabular-nums" style={{ color: "var(--fg-muted)" }}>
                {numeralDeProceso(todos, p.id)}
              </span>{" "}
              {p.nombre}
              {!p.activo && " (archivado)"}
            </span>
            <span className="block text-xs" style={{ color: "var(--fg-muted)" }}>
              {p.pasos.length} paso{p.pasos.length === 1 ? "" : "s"}
            </span>
          </button>
        </li>
      ))}
    </ul>
  )
}
